export function createHoldersFromBoards(count) {
  return new Array(count).fill().map(() => ({
    name: '',
    last: '',
    email: '',
    errors: [],
  }))
}
